<template>
<div v-if="isLoaded">
    <div v-if="content !== 'error'">
        <h1> {{ $t('contentsView') }} </h1>
        <el-button 
            v-if="!content.confirmed" 
            style="float: right; font-size: 20px; margin-left: 10px" 
            type="primary"
            icon="el-icon-edit" 
            @click="$router.push({name: 'ContentEdit', params: {content: content, isEdit: true}})"/>

        <el-card>
            <table>
                <tr>
                    <td class="res-name"> {{ $t('contentsTitle') }} </td>
                    <td class="">
                        <lang-tabs-view :input="content.title ? content.title : {}"/>
                    </td>
                </tr>

                <tr>
                    <td class="res-name"> {{ $t('contentsSubtitle') }} </td>
                    <td class="">
                        <lang-tabs-view :input="content.subtitle ? content.subtitle : {}"/>
                    </td>
                </tr>

                <tr>
                    <td class="res-name"> {{ $t('contentsText') }} </td>
                    <td class="">
                        <lang-tabs-view :isHtml="true" :input="content.text ? content.text : {}"/>
                    </td>
                </tr>
            </table>       
        </el-card>
        <view-shared-buttons/> 
    </div>

    <div v-else>
        <not-found/>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import api from '@/api/api'
import LangTabsView from '../LangTabs/LangTabsView'
import LayoutHeaders from '../LayoutPart/LayoutHeaders'
import NotFound from '../NotFound'
import ViewSharedButtons  from '../Shared/ViewSharedButtons'
import ImagesView from '../UploadFile/ImagesView'

export default {
    components: {
        LayoutHeaders,
        LangTabsView,
        NotFound,
        ViewSharedButtons,
        ImagesView
    },
    data () {
        return {
            emptyText: '',
            content: {
            },
            isLoaded: false
        }
    },
    computed: {
    },
    async created () {
        let content
        await api.fetchSingleContent(this.$route.params.id)
        .then((res) => {
            content = res.data.data            
        })
        .catch((err) => {
            content = 'error'
        })

        this.content = content        
        this.isLoaded = true
        
    }

    
}
</script>

<style scoped>

h1 {
    color: grey;
    font-weight: 500;
    margin-left: 5px;
    display: inline-block;
}

table {
    width: 100%;
}

table > tr > td{
    padding: 15px !important;
    border-bottom: 1px solid #e6e6e6;
    
}

table > tr:last-child > td {
    border: none;
}

table > tr > td:nth-child(2) {
    position: relative;
    margin-left: -3px;
    display: block;
    margin-top: 1px;
}

.res-value-clickable {
    color: #409EFF !important;
    cursor: pointer;
}

.res-name {
    width: 200px;
    color: grey;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Contents/ContentView.vue